<div class="grid-container text-white text-weight-600">
  <span class="header text-size-18 text-weight-600 pl-05"
    >Operador:
    <span class="text-color-primary-1">{{ properties?.operator }}</span></span
  >
  <div class="card">
    <span class="text-size-16 text-res">CAPACIDAD AUTOS</span>
    <sit-icon
      [icon]="Icon.cars_yellow"
      alt="icon indicador automóvil"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.carCapacity }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">CAPACIDAD MOTOS</span>
    <sit-icon
      [icon]="Icon.motorcycle_green"
      alt="icon indicador motocicleta"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{
      properties?.motorcycleCapacity
    }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">CAPACIDAD BICICLETAS</span>
    <sit-icon
      [icon]="Icon.bicycles_green"
      alt="icon indicador bicicletas"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.bicycleCapacity }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">CAPACIDAD BUSES</span>
    <sit-icon
      [icon]="Icon.bus"
      alt="icon indicador buses"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.busCapacity }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res"
      >HORARIO INICIO<br />
      LUNES-VIERNES</span
    >
    <sit-icon
      [icon]="Icon.parking_lva_green"
      alt="icon indicador calendario"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.startHourWeek }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res"
      >HORARIO FIN<br />
      LUNES-VIERNES</span
    >
    <sit-icon
      [icon]="Icon.parking_lvc_green"
      alt="icon indicador calendario"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.endHourWeek }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">HORARIO INICIO SÁBADOS</span>
    <sit-icon
      [icon]="Icon.parking_sa_green"
      alt="icon indicador calendario"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{
      properties?.startHourSaturday
    }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">HORARIO FIN SÁBADOS</span>
    <sit-icon
      [icon]="Icon.parking_sc_green"
      alt="icon indicador calendario"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.endHourSaturday }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">HORARIO INICIO DOMINGOS</span>
    <sit-icon
      [icon]="Icon.parking_da_green"
      alt="icon indicador calendario"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.startHourSunday }}</span>
  </div>
  <div class="card">
    <span class="text-size-16 text-res">HORARIO FIN DOMINGOS</span>
    <sit-icon
      [icon]="Icon.parking_dc_green"
      alt="icon indicador calendario"
      class="mt-05 mb-05"
      [sizeClass]="'icon-size-64 icon-res-mod'"
    ></sit-icon>
    <span class="text-size-16 text-res">{{ properties?.endHourSunday }}</span>
  </div>
</div>
